import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/siteData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-alarm-warning-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90 max-w-xs">
              聚焦网红翻车现场，收录直播事故、翻车视频回放与关键截图。把碎片化的吃瓜信息，整理成可以复盘的完整事件。
            </p>
            <div className="flex items-center gap-2 mt-5">
              <span className="w-8 h-8 rounded-md bg-primary-900 flex items-center justify-center text-background-100">
                <i className="ri-mail-line"></i>
              </span>
              <span className="text-xs text-background-200 break-all">{siteInfo.email}</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">翻车分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category?cat=${cat.slug}`}
                    className="text-sm text-background-200/90 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">网站导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  全部事件
                </Link>
              </li>
              <li>
                <Link to="/category?cat=classic-moments" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  名场面回放
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容原则</h4>
            <ul className="space-y-3">
              <li className="flex gap-2.5 text-sm text-background-200/90">
                <i className="ri-shield-check-line text-accent-400 mt-0.5"></i>
                只呈现可核实的公开信息
              </li>
              <li className="flex gap-2.5 text-sm text-background-200/90">
                <i className="ri-user-heart-line text-accent-400 mt-0.5"></i>
                不针对个人进行人身攻击
              </li>
              <li className="flex gap-2.5 text-sm text-background-200/90">
                <i className="ri-refresh-line text-accent-400 mt-0.5"></i>
                发现错误可随时反馈修订
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {year} {siteInfo.name} · 站内图片为内容示意画面，不包含当事人真实影像
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300">
            <Link to="/about" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              品牌介绍
            </Link>
            <Link to="/faq" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              内容说明
            </Link>
            <Link to="/contact" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              纠错反馈
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}